import { Action, handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { debug } from '../../../utils';
import * as actions from './actions'
import { dragMap } from './actions';
import merge from 'lodash/merge'

const mapReducers = {
    [actions.SET_GOOGLE_MAP]: (state, action) => {
        const { mapComponent } = action.payload;
        return (() => mapComponent);
    }
};

const initialMapState = null;
const GoogleMapReducers = handleActions<any>(mapReducers, initialMapState);
const POSITIONS = ['min', 'mid', 'max']

const _mapStateReducers = {
	[actions.SET_GOOGLE_MAP]: (state, action) => {
    const { mapComponent } = action.payload;
    return { ...state, mapComponent: () => mapComponent };
  },
    [actions.SET_RESULT_SELECTED]: (state, action) => {
      const { selected } = action.payload;
      return {
				...state,
				selected,
				map_controlled: true,
				show_infobox: true
			};
    },
	  [actions.ADJUST_WINDOW_SHADE]: (state, action) => {
			const { direction } = action.payload;
			let { windowShade } = state

			let position = isNaN(windowShade) ? 1 : windowShade + direction
			position = Math.max(Math.min(position, POSITIONS.length - 1), 0)

			return { ...state, windowShade: position}
  	},
    [actions.SET_RESULT_HOVERED]: (state, action) => {
      const { hovered } = action.payload;
			if (hovered === state.hovered) return state;
      return { ...state, hovered };
    },
    [actions.SET_SHOW_INFOBOX]: (state, action) => {
        const { show_infobox } = action.payload;
        return { ...state, show_infobox };
    },
    [actions.SET_MAP_CONTROLLED]: (state, action) => {
        const { map_controlled } = action.payload;
        return { ...state, map_controlled };
    },
  [actions.SET_MAP_LOCATION]: (state, action) => {
		const { lat, lng, zoom } = action.payload
		const newLocation = {
			lat, lng, zoom,
			latitude: lat,
			longitude: lng,
		}
		const map_location = merge({}, state.map_location, newLocation)
		return {...state, map_location}
    }
};

const initialMapStateState = {
	windowShade: 1
};
const mapStateReducers = handleActions<any>(_mapStateReducers, initialMapStateState);

export default { mapComponent: GoogleMapReducers, mapStateReducers };



// WEBPACK FOOTER //
// ./src/app/models/Map/reducers.ts